export const authLoginURL = process.env.REACT_APP_AUTH_LOGIN_URL ?? '';
